<!--
 * @Author: 温静 （wenjing@feihe.com）
 * @Date: 2021-12-22 10:31:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-05-10 14:55:59
 * @Description:
-->
<template>
  <div class="transitMini" v-if="link && bgImage">
    <div class="toMiniPop"
      ref="qrCodePopup"
      @touchmove.prevent
      @mousewheel.prevent
      v-if="toMiniToast">
      <div class="content">
        <img crossorigin="anonymous" :src="canvasImg" alt="小程序二维码">
        <img
          src="./../../../assets/images/food/delete.png"
          class="close"
          @click="toMiniToast = false"
          alt=""
        />
      </div>
    </div>

    <div class="invalid-tips" v-if="hasInvalid == 1">
      <img src="../../../assets/images/activity/openMini/invalid.png" alt="">
      <p>很抱歉，您查看的活动已结束～</p>
    </div>
    <a class="transit-button" v-else :data="!isSystem && is_weixn ? '' : link" @click="!isSystem && is_weixn ? '' : goToMini('transitMini'+ id, link, 1, syntheticQRcodeByImgUrl)">
      <div class="openWrap" :style="'height:'+this.imgElementHeight+'px;'" v-if="!isSystem && is_weixn" >
        <openWxTag
          id='imgElement'
          :path="link"
          :btnStyle="'width:100%;height:'+this.imgElementHeight+'px;z-index:10'"
        >
        </openWxTag>
      </div>
      <img ref="imgElement" @load="getElementHeight()" :src="bgImage" />
    </a>
  </div>
</template>
<style lang="less" scoped>
.transitMini {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  .toMiniPop{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: @expertColorMask;
    width: 100%;
    height: 100%;
    z-index: 1000;
    margin: auto;
    .content {
      background-size: 100% 100%;
      background-repeat: no-repeat;
      position: fixed;
      height: 416px;
      width: 300px;
      margin: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      img {
        width: 100%;
        height: 100%;
      }
      .close {
        width: 24px;
        height: 24px;
        position: absolute;
        bottom: -35px;
        left: 50%;
        transform: translate(-50%);
        display: block;
      }
    }
  }
  .transit-button {
    display: block;
    img {
      display: block;
      width: 100%;
    }
    .openWrap{
      position: absolute;
      z-index: 10;
      width: 100%;
      // height: 1334px;
    }
  }

  .invalid-tips{
    padding-top: 142px;
    img {
      display: block;
      margin: 0 auto;
      width: 156px;
    }
    p {
      margin-top: 25px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }

  }
}
</style>
<script>
import { TestUserAgent, is_weixn, goToMini } from "@/assets/js/common.js";

import openWxTag from "@/components/common/openWeappTag/index.vue" // 打开小程序开放标签
import wx from 'weixin-js-sdk'

export default {
  name: "transitMini",
  data() {
    return {
      link: "", // 跳转的链接地址
      route: '', // 跳转路由地址
      hasInvalid: 1, // 是否失效,默认失效
      bgImage: "",
      isSystem: "",
      is_weixn: "",
      imgElementHeight: 1334,
      timeOutEvent: null,
      canvasImg: '',    // 弹窗合成的二维码
      toMiniToast: false,
      id: '', // 当前活动id，用于缓存数据做区分的
      qrCodeLink: '', // 后端生成的二维码链接
    };
  },
  components: { openWxTag },
  created(){
    this.isSystem = TestUserAgent().isios;
    this.is_weixn = is_weixn();
    if(this.is_weixn){
      this.init()
    }
  },
  mounted() {
    this.getSMSLinkById()
  },
  methods: {
    init() {
      this.$http.get("/wechat/oauth2/getJSSDKConfig?url=" + encodeURIComponent(location.href.split("#")[0]), {}, (res) => {
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ["onMenuShareTimeline"], // 必填，需要使用的JS接口列表
          openTagList: ["wx-open-launch-weapp"] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        })
        wx.ready(function () {
          console.log("ready")
        })
        wx.error(function (res) {
          console.log("err", res)
        })
      })
    },
    getElementHeight(){
      this.imgElementHeight = this.$refs.imgElement.offsetHeight;
      // this.$nextTick(()=>{
      //   this.syntheticQRcodeByImgUrl()
      // })
    },
    goToMini,
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getSMSLinkById() {
      this.id = this.getQueryString("id");
      if(!this.id) {
        return this.$dialog.alert({
          message: "缺少必要参数，请确认链接是否正确",
          confirmButtonText: '知道了'
        });
      }
      this.$http.get("/smsLink/getSmsLinkById", { id: this.id }, res => {
        if (res.code == "200") {
          // document.title = res.data.activityTitle;
          this.qrCodeLink = res.data.qrCode;
          this.link = res.data.link; // 跳转的链接地址
          this.route = res.data.route; // 跳转的链接地址
          this.hasInvalid = Number(res.data.isValid); // 是否失效
          this.bgImage = res.data.imgUrl;
        } else {
          this.$dialog.alert({
            message: res.message,
            confirmButtonText: '知道了'
          });
        }
      })
    },
    // 将背景图片与二维码合成一张图片供用户下载
    syntheticQRcodeByImgUrl(){
      if(!this.qrCodeLink){
        this.$dialog.alert({
          message: "打开微信，搜索星妈优选小程序进入活动页面",
          confirmButtonText: '知道了'
        });
        return;
      }
      // 创建canvas，并设置宽高
      const canvas = document.createElement('canvas');
      canvas.width = 300*3;
      canvas.height = 416*3;
      canvas.style.width = canvas.width + "px";
      canvas.style.height = canvas.height + "px";
      const ctx = canvas.getContext('2d');
      // 创建背景图片的标签，并设置src，使用canvam绘制
      var qrCodeBgImg = document.createElement("img")
      let _this = this;
      qrCodeBgImg.onload = function() {//图片加载完，再draw 和 toDataURL
        ctx.drawImage(qrCodeBgImg, 0, 0, canvas.width, canvas.height);
        // 设置字体
        ctx.font = "normal 42px/60px arial";
        ctx.fillStyle="#666666";
        ctx.fillText('长按保存二维码，微信扫一扫进入', 50, 405*3);
        ctx.font = "bold 42px arial";
        ctx.fillStyle="#111111";
        ctx.fillText('活动页面', 226*3, 405*3);
        // 创建二维码的标签，并设置src，使用canvam绘制
        var qrcodeImg = document.createElement("img")
        qrcodeImg.onload = function(){
          ctx.drawImage(qrcodeImg,90*3, 258*3, 120*3, 136*3);
          _this.canvasImg = canvas.toDataURL('image/png')
          _this.toMiniToast = true;
        }
        // 设置跨域
        qrcodeImg.crossOrigin='Anonymous';
        qrcodeImg.src = _this.qrCodeLink;
      };
      qrCodeBgImg.crossOrigin='Anonymous';
      qrCodeBgImg.src = require("@/assets/images/activity/openMini/qrCode-bg.png");
    },
  },
};
</script>